import {
  et3ParseInteger,
  isDefinedString,
  isNumber,
  isPositiveNumber,
  reduce
} from "et3-type-guards";
import { get, memoize, orderBy, startCase } from "lodash";
import { computed, observable, runInAction } from "mobx";
import queryString from "query-string";
import getUserStore from "..";
import {
  USER_EVENTS_PAGE_LINK,
  USER_MESSAGES_PAGE_LINK,
  USER_PAYMENTS_PAGE_LINK
} from "../../../constants/core-constants";
import {
  CODE_LENGTH,
  COMMENTS_DEFAULT_NUMBER,
  DEFAULT_TIME,
  MAX_NUMBER_OF_COMMENTS,
  MAXIMUM_COMMENT_CHARACTERS,
  MINIMUM_COMMENT_CHARACTERS
} from "../../../constants/input-entries-constants";
import {
  SEARCH_BY_INPUT_USER_ID,
  USER_SEARCH_BY_PLACEHOLDERS
} from "../../../constants/picker-entries-constants";
import {
  MIN_USER_ADVANCED_CRITERIA_SEARCH_NUMBER,
  USER_DATA_KEYS
} from "../../../constants/user-profile";
import { getFormmatedDate } from "../../../helpers/et3-date-helper";
import { checkIfHasBadWordsAndSocialMedia } from "../../../helpers/et3-text-checker/social-media-and-bad-words";
import {
  E_KHATTABAT_USER_ADVANCED_TABLE,
  E_USER_SEARCH_BY,
  StringOrNumber,
  TAlbum,
  TComment,
  TPictureActiveStatus,
  TPoolTable,
  TKhattabatUserAdvancedTable,
  TSearchType,
  TUser,
  TUserSubscriptionStatus
} from "../../../Types";
import getCoreHistoryStore from "../../core/core-history-store";
import getCoreNavigationStore from "../../core/core-navigation-store";
import getCorePersonalStore from "../../core/core-personal-store";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import getUserEventsStore from "../events-store";
import addAdminUserComments from "./add-admin-user-comment";
import changeUsernameOnDatabase from "./change-user-name";
import getAdminUserComments from "./get-user-admin-comments";
import getUserAlbum from "./get-user-album";
import getUsersDataFromDatabase from "./get-users-data";
import getUserLoadMoreStore from "./loadMoreByUserID";
import getApproveRejectStore from "../../approval-reject-store";
import resetAccountOnDatabase from "./reset-account-on-database";
import { escapeTextStringParsing } from "../../../helpers/general";
import textGuard from "et3-text-guard";
import getInvestigationCasesStore from "../../investigation-cases-store";
import getReportsStore from "../../reports-store";
import { TEt3PickerSingleValue } from "../../../TypesNEW";

const userDataDefault = {
  0: {
    userId: 0,
    userUUID: "",
    username: "",
    gender: "",
    religion: "",
    subreligion: "",
    status: "",
    isSilentBanned: 0,
    statusChangeDate: DEFAULT_TIME,
    facebookVerify: "",
    smsVerify: "",
    emailVerify: "",
    appleVerify: "",
    emailNotification: "",
    pushNotification: "",
    descriptionID: -1,
    description: "",
    descriptionStatus: "",
    descriptionLanguage: "",
    peerDescriptionID: -1,
    peerDescription: "",
    peerDescriptionStatus: "",
    peerDescriptionLanguage: "",
    createdOn: "",
    createdFrom: "",
    originCountry: "",
    residenceCountry: "",
    cityName: "",
    selfieVerificationCompletedOn: DEFAULT_TIME,
    numberOfVerifiedApprovedPictures: 0,
    loginCount: 0,
    state: "",
    ipAddress: "",
    verificationStatus: "",
    verificationCode: "",
    referralCode: "",
    mobileAppPlatform: "",
    mobileAppVersion: "",
    deviceId: "",
    device_token: "",
    isFlagged: 0,
    reportsSent: 0,
    reportsReceived: 0,
    warningCount: 0,
    userUnderCSRInvestigation: false,
    userUnderInvestigationAndReadyToResolve: false,
    userUnderCSRReport: 0,
    temporaryBannedCount: 0,
    wasPaying: false,
    isPaidVIP: false,
    isPaidPlus: false,
    isPaidAlkhattabat: false,
    isPaidBoost: false,
    isPaidRewind: false,
    isSubscribedVIP: false,
    isSubscribedPlus: false,
    isSubscribedAlkhattabat: false,
    isSubscribedBoost: false,
    isSubscribedRewind: false,
    isSubscribedSilver: false,
    isSubscribedGold: false,
    isSubscribedPlatinum: false,
    isSubscribedPower: false,
    isPaidSilver: false,
    isPaidGold: false,
    isPaidPlatinum: false,
    isPaidPower: false,
    lastLogin: 0,
    freemiumVIPUntil: DEFAULT_TIME,
    freemiumPLUSUntil: DEFAULT_TIME,
    freemiumSilverUntil: DEFAULT_TIME,
    freemiumGoldUntil: DEFAULT_TIME,
    freemiumPlatinumUntil: DEFAULT_TIME,
    payingKhattabatUntil: DEFAULT_TIME,
    payingVIPUntil: DEFAULT_TIME,
    payingPLUSUntil: DEFAULT_TIME,
    payingBOOSTUntil: DEFAULT_TIME,
    payingREWINDUntil: DEFAULT_TIME,
    payingSilverUntil: DEFAULT_TIME,
    payingGoldUntil: DEFAULT_TIME,
    payingPlatinumUntil: DEFAULT_TIME,
    payingPowerUntil: DEFAULT_TIME,
    isPaid: false,
    userAppLanguage: "",
    deactivatedOn: DEFAULT_TIME,
    deactivationCounter: 0,
    pictures: [
      {
        id: "",
        imageSource: "",
        profilePictureStatus: "",
        selfieVerified: "",
        isActive: false
      }
    ],
    commentsNumber: 0,
    comments: [
      {
        adminName: "",
        adminComment: "",
        commentDate: ""
      }
    ],
    isTester: false,
    profilePublicID: "",
    phoneDetails: "",
    khattabaAssigned: "",
    hasAccessToBoosts: false,
    hasAccessToRewinds: false,
    hasAccessToReadReceipts: false,
    hasAccessToNewConversationsDaily: false,
    hasAccessToNewConversationsWeekly: false,
    hasRemainingBoosts: false,
    hasRemainingRewinds: false,
    hasRemainingReadReceipts: false,
    hasRemainingNewConversationsDaily: false,
    hasRemainingNewConversationsWeekly: false,
    hasAccessToLikes: false,
    hasAccessToLikesDaily: false,
    hasRemainingLikes: false,
    hasRemainingLikesDaily: false,
    emails: [
      {
        userEmail: "",
        verificationPlatform: "",
        verificationActive: 0,
        userActivityEmailsSubscription: 0,
        promotionalEmailsSubscription: 0,
        newMessageEmailsSubscription: 0,
        visitProfileEmailsSubscription: 0,
        likeEmailsSubscriptio: 0,
        userActivityEmailsSettingsOn: 0,
        promotionalEmailsSettingsOn: 0,
        newMessageEmailsSettingsOn: 0,
        visitProfileEmailsSettingsOn: 0,
        likeEmailsSettingsOn: 0
      }
    ],
    quizData: [
      {
        questionId: -1,
        allowedAnswers: 0,
        questionTextEnglish: "",
        subQuestionTextEnglish: "",
        answerTextEnglish: ""
      }
    ]
  }
};
class UserAdvancedStore {
  searchType = observable.box<TSearchType>("option_search");
  searchByInput = observable.box<string>("userId");
  advancedSearchInput = observable.box<StringOrNumber>();
  criteriaSearchUserName = observable.box<string>("");
  criteriaSearchNationality = observable.box<TEt3PickerSingleValue>({
    label: "",
    value: ""
  });
  criteriaSearchResidenceCountry = observable.box<TEt3PickerSingleValue>({
    label: "",
    value: ""
  });
  criteriaSearchAge = observable.box<TEt3PickerSingleValue>({
    label: "",
    value: ""
  });
  criteriaSearchHeight = observable.box<TEt3PickerSingleValue>({
    label: "0",
    value: "0"
  });
  criteriaSearchWeight = observable.box<TEt3PickerSingleValue>({
    label: "0",
    value: "0"
  });
  userData = observable.map<number, TUser>(userDataDefault);
  changeStatusInput = observable.box<TEt3PickerSingleValue>({
    label: "",
    value: ""
  });
  changeUsernameInput = observable.box<string>("");
  userIDs = observable.box<number[]>([]);
  currentUserId = observable.box<number>(0);
  currentIndex = observable.box<number>(0);
  userAlbumIndex = observable.box<number>(-1);
  adminCommentText = observable.box<string>("");
  showComments = observable.box<boolean>(true);
  criteriaSearchDescription = observable.box<string>("");
  criteriaSearchPeerDescription = observable.box<string>("");
  criteriaSearchAccountCreatedOn = observable.box<TEt3PickerSingleValue>({
    label: "",
    value: ""
  });
  descriptionAlignment = observable.box<"left" | "right">("right");
  peerDescriptionAlignment = observable.box<"left" | "right">("right");
  shouldChangeFromClientSide = observable.box<boolean>(false);
  adminPoolTable = observable.box<TPoolTable>();
  userAdvancedTableToShow = observable.box<TKhattabatUserAdvancedTable>(
    E_KHATTABAT_USER_ADVANCED_TABLE.USER_DATA
  );

  setUserAdvancedTableToShow = (state: TKhattabatUserAdvancedTable) => {
    runInAction(() => {
      this.userAdvancedTableToShow.set(state);
    });
  };

  setChangeStatusInput = (status: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.changeStatusInput.set(status);
    });
  };

  getInputPlaceholder = computed(() => {
    const picked = this.searchByInput.get();
    const placeholder = get(USER_SEARCH_BY_PLACEHOLDERS, picked, "");
    return placeholder;
  });

  getSearchInputDisplayValue = computed(() => {
    const value = this.advancedSearchInput.get();
    if (this.searchByInput.get() !== E_USER_SEARCH_BY.USER_ID) {
      return `${value}`;
    }
    return isPositiveNumber(value) ? `${value}` : "";
  });

  ifCommentsExist = computed(() => {
    const commentsArray = reduce(
      () => this.userData.get(this.currentUserId.get()).comments,
      []
    );
    return commentsArray.length > 0;
  });

  getNewAddedComment = computed(() => {
    const userID = this.currentUserId.get();
    const commentsArray = reduce(() => this.userData.get(userID).comments, []);
    const commentsArrayOrdered = orderBy(
      commentsArray,
      ["commentDate"],
      ["desc"]
    );

    return commentsArrayOrdered;
  });

  isCommentAccepted = computed(() => {
    const commentNumberOfCharacters = this.adminCommentText.get().trim().length;
    const maxNumberOfComments =
      commentNumberOfCharacters <= MAXIMUM_COMMENT_CHARACTERS;
    const minNumberOfComments =
      commentNumberOfCharacters >= MINIMUM_COMMENT_CHARACTERS;
    const commentAccepted = maxNumberOfComments && minNumberOfComments;
    return commentAccepted;
  });

  showLoadMore = computed(() => {
    const userID = this.currentUserId.get();
    const commentNumbers = reduce(
      () => this.userData.get(userID).commentsNumber,
      0
    );
    const commentsArray = reduce(() => this.userData.get(userID).comments, []);
    const loadMoreValue = reduce(
      () => getUserLoadMoreStore(userID).loadMore.get(),
      COMMENTS_DEFAULT_NUMBER
    );
    const theLastComment = commentsArray.length < commentNumbers;
    const lowerThanMaxComments = loadMoreValue < MAX_NUMBER_OF_COMMENTS;
    return theLastComment && lowerThanMaxComments;
  });

  isUserStatusDeleted = computed(() => {
    const userID = reduce(() => this.currentUserId.get(), 0);
    const data = reduce(() => this.userData.get(userID), userDataDefault[0]);
    const userStatus = reduce(() => data.status, "");
    return userStatus === "deleted";
  });

  isChangeStatusEnabled = computed(() => {
    const userID = reduce(() => this.currentUserId.get(), 0);
    const changeStatus = this.changeStatusInput.get().value;
    const oldStatus = reduce(
      () => getUserAdvancedStore().userData.get(userID).status,
      ""
    );
    const { userIsUnderCsrInvestigation } =
      getUserAdvancedStore().currentUserIsUnderCsrInvestigation.get();
    return (
      isDefinedString(this.changeStatusInput.get().value) &&
      this.changeStatusInput.get().value !== "deactivated" &&
      changeStatus !== oldStatus &&
      !userIsUnderCsrInvestigation &&
      !this.currentUserIsUnderCsrReport.get()
    );
  });

  shouldShowOptionForm = computed(() => {
    return this.searchType.get() === "option_search";
  });

  shouldShowCriteriaForm = computed(() => {
    return this.searchType.get() === "criteria_search";
  });

  userStatusDeleted = computed(() => {
    const userID = reduce(() => this.currentUserId.get(), -1);
    const userData = reduce(
      () => this.userData.get(userID),
      userDataDefault[0]
    );
    const isCurrentUserDeleted = userData.status === "deleted";
    return isCurrentUserDeleted;
  });

  getUserDescriptionDetails = computed(() => {
    const userID = reduce(() => this.currentUserId.get(), -1);
    const userData = reduce(
      () => this.userData.get(userID),
      userDataDefault[0]
    );
    const description = reduce(() => userData.description, "");
    const peerDescription = reduce(() => userData.peerDescription, "");
    const descriptionStatus = reduce(() => userData.descriptionStatus, "");
    const peerDescriptionStatus = reduce(
      () => userData.peerDescriptionStatus,
      ""
    );
    const pendingDescription = descriptionStatus === "PENDING";
    const pendingPeerDescription = peerDescriptionStatus === "PENDING";

    return {
      userID,
      description,
      peerDescription,
      descriptionStatus,
      peerDescriptionStatus,
      pendingDescription,
      pendingPeerDescription
    };
  });

  criteriaSearchNumber = computed(() => {
    return this.arrayTrueStatesAddition([
      isDefinedString(this.criteriaSearchUserName.get().trim()),
      isDefinedString(this.criteriaSearchNationality.get().value.trim()),
      isDefinedString(this.criteriaSearchResidenceCountry.get().value.trim()),
      isDefinedString(this.criteriaSearchAccountCreatedOn.get().value.trim()),
      isPositiveNumber(parseInt(this.criteriaSearchAge.get().value, 10)),
      isPositiveNumber(parseInt(this.criteriaSearchHeight.get().value, 10)),
      isPositiveNumber(parseInt(this.criteriaSearchWeight.get().value, 10))
    ]);
  });

  disableSearchGetButton = computed(() => {
    switch (this.searchType.get()) {
      case "option_search":
        const ifInputTypeUserID =
          getUserAdvancedStore().searchByInput.get() ===
          SEARCH_BY_INPUT_USER_ID;
        if (ifInputTypeUserID) {
          const intAdvancedSearch = parseInt(
            `${this.advancedSearchInput.get()}`,
            10
          );
          return !isPositiveNumber(intAdvancedSearch);
        } else {
          return !isDefinedString(this.advancedSearchInput.get());
        }
      case "criteria_search":
        const userAdvancedStore = getUserAdvancedStore();
        const criteriaSearchDescription =
          userAdvancedStore.criteriaSearchDescription.get().trim();
        const criteriaSearchPeerDescription =
          userAdvancedStore.criteriaSearchPeerDescription.get().trim();
        if (
          isDefinedString(criteriaSearchDescription) ||
          isDefinedString(criteriaSearchPeerDescription)
        ) {
          return false;
        } else {
          return !(
            this.criteriaSearchNumber.get() >=
            MIN_USER_ADVANCED_CRITERIA_SEARCH_NUMBER
          );
        }
      default:
        return true;
    }
  });

  currentUserIsUnderCsrInvestigation = computed(() => {
    const currentUserId = this.currentUserId.get();
    const userData = this.userData.get(currentUserId);
    const userIsUnderCsrInvestigation = reduce(
      () => userData.userUnderCSRInvestigation,
      false
    );
    const userUnderInvestigationAndReadyToResolve = reduce(
      () => userData.userUnderInvestigationAndReadyToResolve,
      false
    );

    return {
      userIsUnderCsrInvestigation,
      userUnderInvestigationAndReadyToResolve
    };
  });

  currentUserIsUnderCsrReport = computed(() => {
    const currentUserId = this.currentUserId.get();
    const userData = this.userData.get(currentUserId);
    const currentUserIsUnderCsrReport =
      reduce(() => userData.userUnderCSRReport, 0) === 1;
    const userIsActive = reduce(() => userData.status, "") === "active";
    return currentUserIsUnderCsrReport && userIsActive;
  });

  isActionButtonsDisabled = computed(() => {
    const userID = reduce(() => this.currentUserId.get(), -1);
    const userData = reduce(
      () => this.userData.get(userID),
      userDataDefault[0]
    );
    const currentUserIsBanned = userData.status === "banned";
    const { userIsUnderCsrInvestigation } =
      this.currentUserIsUnderCsrInvestigation.get();
    const currentUserIsUnderCsrReport = this.currentUserIsUnderCsrReport.get();
    return (
      currentUserIsBanned ||
      userIsUnderCsrInvestigation ||
      currentUserIsUnderCsrReport
    );
  });

  checkURLSearch = async (search: string) => {
    if (isDefinedString(search)) {
      getUserAdvancedStore().setSearchByInput("userId");
      const searchID = queryString.parse(search).id;
      if (isDefinedString(searchID) && searchID !== "0") {
        getUserAdvancedStore().advancedSearchInput.set(
          et3ParseInteger(searchID)
        );
        await getUserAdvancedStore().getUserData(false);
      }
    }
  };

  getNewLoadComments = async () => {
    const userID = reduce(() => this.currentUserId.get(), 0);
    const loadMoreValue = reduce(
      () => getUserLoadMoreStore(userID).loadMore.get(),
      COMMENTS_DEFAULT_NUMBER
    );
    const limit = loadMoreValue + COMMENTS_DEFAULT_NUMBER;
    getCoreUIStore().setIsLoading("USER_ADVANCED", true);
    const { userAdminComments, commentsNumber } = await this.getUserComments(
      userID,
      limit
    );
    getCoreUIStore().setIsLoading("USER_ADVANCED", false);
    const oldUserData = reduce(
      () => this.userData.get(userID),
      userDataDefault[0]
    );
    const newUserData = Object.assign(oldUserData, {
      comments: userAdminComments,
      commentsNumber: commentsNumber
    });
    getUserAdvancedStore().userData.set(userID, newUserData);
    getUserLoadMoreStore(userID).loadMore.set(limit);
  };

  getDescriptionAlignment = (descriptionLanguage: string) => {
    const ifDescriptionLanguageArabicOrNotSet =
      descriptionLanguage === "AR" || descriptionLanguage === "LANG_NOT_SET";
    return ifDescriptionLanguageArabicOrNotSet ? "right" : "left";
  };

  getDescriptionTone = (
    descriptionStatus: string
  ): { borderColor: string; statusImage: string } => {
    switch (descriptionStatus) {
      case "PENDING":
        return { borderColor: "grey.600", statusImage: "pending-logo" };
      case "APPROVED":
        return { borderColor: "success.main", statusImage: "accepted-logo" };
      default:
        return { borderColor: "error.main", statusImage: "rejected-logo" };
    }
  };

  getDescriptionHighlight = (description: string) => {
    const { hasBadWords, hasSocialMedia } =
      checkIfHasBadWordsAndSocialMedia(description);
    if (hasBadWords) {
      return { bgcolor: "error.main", color: "common.white" };
    }
    if (hasSocialMedia) {
      return { bgcolor: "warning.main", color: "common.white" };
    }
    return { bgcolor: "transparent", color: "text.primary" };
  };

  getUserStatusColor = (userStatus: string) => {
    switch (userStatus) {
      case "active":
        return "success";
      default:
        return "error";
    }
  };

  setSearchType = (searchType: TSearchType) => {
    runInAction(() => {
      this.searchType.set(searchType);
    });
  };

  setSearchByInput = (searchType: string) => {
    runInAction(() => {
      this.searchByInput.set(searchType);
    });
  };

  changeSearchType = (value: string) => {
    switch (value) {
      case "criteria_search":
      case "option_search":
        this.setSearchType(value);
        return;
      default:
        return;
    }
  };

  changeSearchByInput = (value: string) => {
    runInAction(() => this.advancedSearchInput.set(""));
    this.setSearchByInput(value);
  };

  setCriteriaSearchUserName = (userName: string) => {
    runInAction(() => {
      const userNameValue = userName.trim();
      this.criteriaSearchUserName.set(userNameValue);
    });
  };

  setCriteriaSearchNationality = (nationality: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.criteriaSearchNationality.set(nationality);
    });
  };

  setCriteriaSearchResidenceCountry = (
    residenceCountry: TEt3PickerSingleValue
  ) => {
    runInAction(() => {
      this.criteriaSearchResidenceCountry.set(residenceCountry);
    });
  };

  setCriteriaSearchAge = (age: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.criteriaSearchAge.set(age);
    });
  };

  setCriteriaSearchHeight = (height: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.criteriaSearchHeight.set(height);
    });
  };

  setCriteriaSearchWeight = (weight: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.criteriaSearchWeight.set(weight);
    });
  };

  setCriteriaSearchDescription = (description: string) => {
    runInAction(() => {
      this.criteriaSearchDescription.set(description);
    });
  };

  setCriteriaSearchPeerDescription = (peerDescription: string) => {
    runInAction(() => {
      this.criteriaSearchPeerDescription.set(peerDescription);
    });
  };

  setCriteriaSearchAccountCreatedOn = (createdOn: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.criteriaSearchAccountCreatedOn.set(createdOn);
    });
  };

  arrayTrueStatesAddition = (array: boolean[]): number => {
    let result = 0;
    for (let i = 0; i < array.length; i++) {
      result = array[i] ? result + 1 : result;
    }
    return result;
  };

  setAdminPoolTable = (poolTable: TPoolTable) => {
    runInAction(() => {
      this.adminPoolTable.set(poolTable);
    });
  };

  resetData = () => {
    this.currentIndex.set(0);
    this.userAlbumIndex.set(0);
    this.currentUserId.set(0);
    this.userIDs.set([]);
    this.userData.clear();
  };

  getUserData = async (shouldSetURL: boolean) => {
    await getUsersDataFromDatabase();
    if (shouldSetURL) {
      getCoreHistoryStore()
        .history.get()
        .push({
          pathname: "/users/advanced",
          search: `?id=${this.currentUserId.get()}`
        });
    }
    return;
  };

  getUserPictureFromAlbum = async (userID: number) => {
    const result: {
      pictures: {
        id: string;
        pic_resized: string;
        accepted: string;
        selfie_verified: string;
        is_cover: boolean;
        status: TPictureActiveStatus;
      }[];
    } = await getUserAlbum(userID);
    const pictures = reduce(() => result.pictures, []);

    return { pictures };
  };

  getUserComments = async (userID: number, limit: number) => {
    const result: {
      comments: {
        commentsRaw: TComment[];
        commentsNumber: number;
      };
    } = await getAdminUserComments(userID, limit);
    const userAdminComments = reduce(
      () => result.comments.commentsRaw,
      [
        {
          adminName: "",
          adminComment: "",
          commentDate: ""
        }
      ]
    );
    const commentsNumber = reduce(() => result.comments.commentsNumber, 0);
    return {
      userAdminComments,
      commentsNumber
    };
  };

  addUserComments = async (userID: number, addUserCommentText: string) => {
    const commentText = escapeTextStringParsing(addUserCommentText);
    const result: {
      addedRows: number;
    } = await addAdminUserComments(userID, commentText);
    const addedComments = reduce(() => result.addedRows, 0);

    return { addedComments };
  };

  addAndClearAdminComments = async (userID: number, commentText: string) => {
    runInAction(() => {
      getCorePopUpStore().closeConfirmationPopUps();
      this.addUserComments(userID, commentText);
    });
  };

  setAdminUserComment = (comment: string) => {
    runInAction(() => {
      this.adminCommentText.set(comment);
    });
  };

  setPrevUser = () => {
    const index = this.currentIndex.get();
    if (index === 0) {
      return;
    }
    const newIndex = index - 1;
    this.currentIndex.set(newIndex);
    const userId = this.userIDs.get()[newIndex];
    this.currentUserId.set(userId);
    this.userAlbumIndex.set(this.userData.get(userId).mainPictureIndex);
  };
  setNextUser = () => {
    const index = this.currentIndex.get();
    if (index === this.userIDs.get().length - 1) {
      return;
    }
    const newIndex = index + 1;
    this.currentIndex.set(newIndex);
    const userId = this.userIDs.get()[newIndex];
    this.currentUserId.set(userId);
    this.userAlbumIndex.set(this.userData.get(userId).mainPictureIndex);
  };
  goToPrevUser = () => {
    this.setPrevUser();
    getCoreNavigationStore().setURLSearchID(this.currentUserId.get());
  };
  goToNextUser = () => {
    this.setNextUser();
    getCoreNavigationStore().setURLSearchID(this.currentUserId.get());
  };
  showNextPicture = () => {
    const pictures = reduce(
      () => this.userData.get(this.currentUserId.get()).pictures,
      []
    );
    const currentIndex = reduce(() => this.userAlbumIndex.get(), 0);
    runInAction(() =>
      this.userAlbumIndex.set(Math.min(currentIndex + 1, pictures.length - 1))
    );
  };
  showPreviousPicture = () => {
    const currentIndex = reduce(() => this.userAlbumIndex.get(), 0);
    runInAction(() => this.userAlbumIndex.set(Math.max(currentIndex - 1, 0)));
  };

  goToUserEvents = async (id: number) => {
    getUserStore().setUserIDInput(id);
    await getUserEventsStore().getUserEvents();
  };
  goToUserMessagesNewTab = (id: number) => {
    getCoreHistoryStore().openNewTab(`/users/messages?id=${id}`);
  };
  goToUserMessagesPage = async () => {
    const userID = this.currentUserId.get();
    getCoreNavigationStore().navigateToPage(
      USER_MESSAGES_PAGE_LINK,
      `id=${userID}`
    );
    await getCorePersonalStore().insertAdminEvent({
      eventName: "GO_TO_MESSAGES",
      fromPage: "USER_ADVANCED",
      userID,
      extraData: {}
    });
  };
  goToUserPaymentsPage = async () => {
    const userID = this.currentUserId.get();
    getCoreNavigationStore().navigateToPage(
      USER_PAYMENTS_PAGE_LINK,
      `id=${userID}`
    );
    await getCorePersonalStore().insertAdminEvent({
      eventName: "GO_TO_PAYMENTS",
      fromPage: "USER_ADVANCED",
      userID,
      extraData: {}
    });
  };
  goToUserEventsPage = async () => {
    const userID = this.currentUserId.get();
    getCoreNavigationStore().navigateToPage(USER_EVENTS_PAGE_LINK, `id=${userID}`);
    this.goToUserEvents(userID);
    await getCorePersonalStore().insertAdminEvent({
      eventName: "GO_TO_EVENTS",
      fromPage: "USER_ADVANCED",
      userID,
      extraData: {}
    });
  };

  changeStatus = async ({ userId }: { userId: number }) => {
    const changeStatus = this.changeStatusInput.get().value;
    const oldStatus = getUserAdvancedStore().userData.get(userId).status;
    const userUUID = getUserAdvancedStore().userData.get(userId).userUUID;
    if (changeStatus === oldStatus || !isDefinedString(changeStatus)) {
      return;
    }

    await getUserStore().changeUserStatus({
      userId,
      userUUID,
      selectedReasons: [],
      showTBW: true,
      userOldStatus: oldStatus,
      userStatus: changeStatus,
      pageName: "USER_ADVANCED"
    });
  };

  getUserSubscriptionStatus = computed((): TUserSubscriptionStatus => {
    const data = this.userData.get(this.currentUserId.get());

    return {
      isPaidAlkhattabat: reduce(() => data.isPaidAlkhattabat, false),
      isSubscribedAlkhattabat: reduce(
        () => data.isSubscribedAlkhattabat,
        false
      ),
      isPaidVIP: reduce(() => data.isPaidVIP, false),
      isSubscribedVIP: reduce(() => data.isSubscribedVIP, false),
      isPaidPlus: reduce(() => data.isPaidPlus, false),
      isSubscribedPlus: reduce(() => data.isSubscribedPlus, false),
      isPaidBoost: reduce(() => data.isPaidBoost, false),
      isSubscribedBoost: reduce(() => data.isSubscribedBoost, false),
      isPaidRewind: reduce(() => data.isPaidRewind, false),
      isSubscribedRewind: reduce(() => data.isSubscribedRewind, false),
      isPaidSilver: reduce(() => data.isPaidSilver, false),
      isSubscribedSilver: reduce(() => data.isSubscribedSilver, false),
      isPaidGold: reduce(() => data.isPaidGold, false),
      isSubscribedGold: reduce(() => data.isSubscribedGold, false),
      isPaidPlatinum: reduce(() => data.isPaidPlatinum, false),
      isSubscribedPlatinum: reduce(() => data.isSubscribedPlatinum, false),
      isPaidPower: reduce(() => data.isPaidPower, false),
      isSubscribedPower: reduce(() => data.isSubscribedPower, false),
      hasAccessToBoosts: reduce(() => data.hasAccessToBoosts, false),
      hasAccessToRewinds: reduce(() => data.hasAccessToRewinds, false),
      hasAccessToReadReceipts: reduce(
        () => data.hasAccessToReadReceipts,
        false
      ),
      hasAccessToNewConversationsDaily: reduce(
        () => data.hasAccessToNewConversationsDaily,
        false
      ),
      hasAccessToNewConversationsWeekly: reduce(
        () => data.hasAccessToNewConversationsWeekly,
        false
      ),
      hasRemainingBoosts: reduce(() => data.hasRemainingBoosts, false),
      hasRemainingRewinds: reduce(() => data.hasRemainingRewinds, false),
      hasRemainingReadReceipts: reduce(
        () => data.hasRemainingReadReceipts,
        false
      ),
      hasRemainingNewConversationsDaily: reduce(
        () => data.hasRemainingNewConversationsDaily,
        false
      ),
      hasRemainingNewConversationsWeekly: reduce(
        () => data.hasRemainingNewConversationsWeekly,
        false
      ),
      hasAccessToLikes: reduce(() => data.hasAccessToLikes, false),
      hasAccessToLikesDaily: reduce(() => data.hasAccessToLikesDaily, false),
      hasRemainingLikes: reduce(() => data.hasRemainingLikes, false),
      hasRemainingLikesDaily: reduce(() => data.hasRemainingLikesDaily, false)
    };
  });

  restAccountPopUP = async (userUUID: string) => {
    getCorePopUpStore().closeConfirmationPopUps();
    await getUserAdvancedStore().resetUserAccount({ userUUID });
    await getUserAdvancedStore().getUserData(true);
  };

  resetUserAccount = async ({ userUUID }: { userUUID: string }) => {
    return await resetAccountOnDatabase(userUUID);
  };

  changeUsername = async (userId: number) => {
    return await changeUsernameOnDatabase(userId);
  };

  addComment = (userID: number, commentText: string) => {
    const date = new Date();
    const commentDate = getFormmatedDate(date);
    const oldUserData = reduce(
      () => this.userData.get(userID),
      userDataDefault[0]
    );
    const adminName = getCorePersonalStore().user.get().fullName;
    const loadMoreValue = oldUserData.comments.push({
      adminName: adminName,
      adminComment: reduce(() => commentText, ""),
      commentDate: reduce(() => commentDate, "")
    });
    const newUserData = Object.assign(oldUserData, {
      commentsNumber: oldUserData.commentsNumber + 1
    });
    getUserAdvancedStore().userData.set(userID, newUserData);
    getUserLoadMoreStore(userID).loadMore.set(loadMoreValue);
  };

  cleanPoolFromAdvanced = async () => {
    const poolTable = this.adminPoolTable.get();
    switch (poolTable) {
      case "APPROVAL":
        await getApproveRejectStore().cleanPool();
        break;
      case "INVESTIGATION_CASES":
        await getInvestigationCasesStore().cleanPool();
        break;
      case "REPORT":
        await getReportsStore().cleanReportsPool();
        break;
    }
    this.setAdminPoolTable("");
  };

  getPictureBorderColor = (profilePictureStatus: string) => {
    switch (profilePictureStatus) {
      case "Y":
        return "success.main";
      case "N":
        return "error.main";
      default:
        return "grey.400";
    }
  };

  getUserDataRows = () => {
    const data = this.userData.get(this.currentUserId.get());
    return USER_DATA_KEYS.map((key) => {
      const value = reduce(() => `${data[key]}`, "");
      if (key === "verificationStatus") {
        return {
          attribut: reduce(() => startCase(key), ""),
          value: value === "no_email" ? "not_verified" : value
        };
      }
      return { attribut: startCase(key), value };
    });
  };

  getImageSource = (isImageActive: boolean, profilePictureStatus: string) => {
    return isImageActive
      ? profilePictureStatus === "Y"
        ? "accepted-logo"
        : profilePictureStatus === "N"
          ? "rejected-logo"
          : "pending-logo"
      : "trash-can-solid";
  };

  getImageData = (picture: TAlbum) => {
    const id = reduce(() => picture.id, "");
    const isPictureActive = reduce(() => picture.isActive, false);
    const selfieVerified = reduce(() => picture.selfieVerified, "");
    const profilePictureStatus = reduce(() => picture.profilePictureStatus, "");
    const source = reduce(() => picture.imageSource, "");
    return {
      id,
      isPictureActive,
      selfieVerified,
      profilePictureStatus,
      source
    };
  };

  imageChangeStatus = async (
    profilePictureStatus: string,
    userID: number,
    userUUID: string,
    currentIndex: number,
    currentImageID: string
  ) => {
    if (profilePictureStatus === "Y") {
      this.userData.get(userID).pictures[currentIndex].profilePictureStatus =
        "N";
      await getApproveRejectStore().rejectUserPicture(
        userID,
        userUUID,
        "USER_ADVANCED",
        currentImageID,
        false,
        ""
      );
    }
    if (profilePictureStatus === "N") {
      getUserAdvancedStore().userData.get(userID).pictures[
        currentIndex
      ].profilePictureStatus = "Y";
      await getApproveRejectStore().approveUserPicture(
        userID,
        userUUID,
        "USER_ADVANCED",
        currentImageID,
        false,
        ""
      );
    }
  };

  imageAcceptRejectStatus = async (
    imageName: string,
    userID: number,
    userUUID: string,
    currentIndex: number,
    currentImageID: string
  ) => {
    if (imageName === "rejected-logo") {
      await getApproveRejectStore().rejectUserPicture(
        userID,
        userUUID,
        "USER_ADVANCED",
        currentImageID,
        true,
        ""
      );
      if (this.shouldChangeFromClientSide.get()) {
        getUserAdvancedStore().userData.get(userID).pictures[
          currentIndex
        ].profilePictureStatus = "N";
        this.shouldChangeFromClientSide.set(false);
      }
    }
    if (imageName === "accepted-logo") {
      await getApproveRejectStore().approveUserPicture(
        userID,
        userUUID,
        "USER_ADVANCED",
        currentImageID,
        true,
        ""
      );
      if (this.shouldChangeFromClientSide.get()) {
        getUserAdvancedStore().userData.get(userID).pictures[
          currentIndex
        ].profilePictureStatus = "Y";
        this.shouldChangeFromClientSide.set(false);
      }
    }
  };

  validatePhoneNumber = (value: StringOrNumber) => {
    // Regex To Validate Phone Number to Accept Only Digits And +
    const phoneNumberRegex = /^[0-9+]+$/;
    const parsedValue = value.toString();
    return phoneNumberRegex.test(parsedValue);
  };

  handleOnChooseInputAdvanced = (
    value: StringOrNumber,
    isPhoneNumberOption: boolean,
    ifInputTypeUserID: boolean,
    isProfileID: boolean
  ) => {
    if (isProfileID) {
      this.setPorifleIDSearchText(`${value}`);
    } else if (
      isPhoneNumberOption &&
      (value === "" || this.validatePhoneNumber(value))
    ) {
      this.advancedSearchInput.set(value);
    } else if (ifInputTypeUserID) {
      const intValue = isNumber(value) ? value : parseInt(value, 10);
      this.advancedSearchInput.set(intValue);
    } else {
      this.advancedSearchInput.set(value);
    }
  };

  checkIfValidProfileID = (value: StringOrNumber) => {
    const isOnlyEnglishCharactersAndNumbers =
      textGuard.checkIfEnglishNumbersAndCharacters(`${value}`);
    const isValidProdileID =
      `${value}`.length === CODE_LENGTH && isOnlyEnglishCharactersAndNumbers;
    return isValidProdileID;
  };

  setPorifleIDSearchText = (value: string) => {
    const isOnlyEnglishCharactersAndNumbers =
      textGuard.checkIfEnglishNumbersAndCharacters(value);
    const isValidProdileID =
      value.length <= CODE_LENGTH && isOnlyEnglishCharactersAndNumbers;
    if (isValidProdileID) {
      this.advancedSearchInput.set(value);
    } else {
      return;
    }
  };
}

const getUserAdvancedStore = memoize(
  () => new UserAdvancedStore(),
  () => 1
);
export default getUserAdvancedStore;
